import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserState } from "../../../../redux/features/auth-slice";
import { hasPermission } from "../../../../core/utils";
import { UserRole } from "../../../../redux/features/user-slice";
import { EditOutlined } from "../../../../components/icons/edit-outlined";
import { TrashOutlined } from "../../../../components/icons/trash-outlined";
import { adminCat, mgTeam } from "../../../../core/utils/constants";

interface Props {
  id: string;
  onUpdate: () => void;
  onDelete: () => void;
}

export default function PropertyActions(props: Props) {
  const { id, onUpdate, onDelete } = props;

  const user = useSelector(getUserState).data;

  const [unlockOptions, setUnlockOptions] = useState<boolean>(false);

  useEffect(() => {
    if (user) {
      setUnlockOptions(
        hasPermission(
          user,
          [adminCat.id],
          [UserRole.Admin, UserRole.Supervisor]
        )
      );
    }
  }, [user]);

  return (
    <div
      key={id}
      className="absolute flex items-center right-1 top-1 bottom-1 border border-divider rounded-lg p-1 space-x-1 bg-background-paper"
    >
      <label
        title="Rename"
        className="rounded hover:bg-gray-200 cursor-pointer p-1"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (unlockOptions) {
            onUpdate();
          }
        }}
      >
        <EditOutlined
          className={`h-4 w-4 ${
            unlockOptions ? "text-text-primary" : "text-action-disabled"
          }`}
        />
      </label>
      <label
        title="Delete"
        className="rounded hover:bg-gray-200 cursor-pointer p-1"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (unlockOptions) {
            onDelete();
          }
        }}
      >
        <TrashOutlined
          className={`h-4 w-4 ${
            unlockOptions ? "text-error-main" : "text-action-disabled"
          }`}
        />
      </label>
    </div>
  );
}
